import {gql} from 'apollo-angular';


export const toolboxContentGql = gql`
query ReloadToolboxContentGql($adoptedEventId: [Int!]) {
  AdoptedEvent(adoptedEventId: $adoptedEventId) {
    tieredToolboxContent {
      subject
      content
      emgmtOocpeTemplateId
      sysTemplateTypeName
      odefOrgOfficeTemplateId
      sysTemplateTypeDescription
      pdefProgramGroupTemplateId
      pdefProgramTemplateId
    }
    tieredDocuments {
      sysTemplateTypeName
      sysTemplateTypeDescription
      subject
      content
      odefOrgOfficeTemplateId
      pdefProgramGroupTemplateId
      pdefProgramTemplateId
    }
  }
}
`;